import webAPI from "../api/web-api-2";
import * as logging from "../utils/log";
import {Collection} from "../lib/event-interface";
import {Chat, ChatConfig, PicUpStream, Provider} from "vchat-core";

let initialized : boolean = false;

export const events : Collection = new Collection("vx-server");
const internalEvents : Collection = new Collection("vx-server-internal");

declare let ChatModule : any;
declare let publish : any;
declare let subscribe : any;

declare let RECEIVE_PERFORMER_IMAGE : any;
declare let RECEIVE_STREAM_IMAGE: any;
declare let RECEIVE_RTMP_ADDRESS: any;
declare let RECEIVE_HLS_ADDRESS: any;
declare let RECEIVE_MESSAGE : any;
declare let CS_START_CHAT_SUCCESS : any;
declare let CS_START_TEXT_SUCCESS : any;
declare let CS_START_AUDIO_SUCCESS : any;
declare let CS_START_UPSTREAM_SUCCESS : any;
declare let CS_STOP_CHAT : any;
declare let CS_SEND_TIP_SUCCESS : any;
declare let CS_SEND_TIP_FAILURE : any;
declare let CS_MUTE : any;
declare let CS_UNMUTE : any;

declare let START_TEXT_REQUEST : any;
declare let START_VIDEO_REQUEST : any;
declare let START_UPSTREAM_REQUEST : any;
declare let STOP_UPSTREAM_REQUEST : any;
declare let SEND_UPSTREAM_DATA_URL_REQUEST : any;
declare let SEND_MESSAGE_REQUEST : any;
declare let STOP_CHAT_REQUEST : any;

let cam2camEnabled = false;

let vxChat = null;
let vxSourceSet = null;
let vxPicUpStream = null;

let cam2CamSnapshotContainer = null;

function log(...args)
{
	logging.log("Sxc.Chat.VxServer", ...args);
}

function error(...args)
{
	logging.error("Sxc.Chat.VxServer", ...args);
}

export function init()
{
	if (initialized) return;

	log("Initializing VisitX Server handler...");

	initialized = true;
}

export function requestCam2Cam()
{
	if(vxChat == null) { return; }

	vxChat.startUpstream().then((targetResult) => {
		cam2camEnabled = true;

		vxPicUpStream = new PicUpStream(new Cam2CamSnapshotProvider());
		vxPicUpStream.publish(targetResult.jpeg[0].stream, targetResult.jpeg[0].fps);
	}).catch((r) => {});
}

export function sendCam2Cam(pic)
{
	if (!cam2camEnabled) return;

	cam2CamSnapshotContainer = pic;
}

export function disableCam2Cam()
{
	cam2camEnabled = false;

	if(vxChat == null) { return; }

	vxPicUpStream.stop();
	vxPicUpStream = null;

	vxChat.stopUpstream();
}

export function getOnlineState(roomID : string)
{
	return webAPI.get("member/visitx/canStartChat", {roomID})
		.then((r : any) => {
			return r.online;
		})
}

export function sendMessage(msg : string)
{
	vxChat.sendMessage(msg);
}

export function stopChat()
{
	cam2camEnabled = false;

	if(vxChat == null) { return; }

	vxChat.close();
}

export function startChat(roomID : string, streamMode : "rtmp" | "hls")
{
	internalEvents.off("rtmpAddressReceived");
	internalEvents.off("hlsAddressReceived");

	return new Promise((resolve, reject) =>
	{
		webAPI.post("member/visitx/startChat", {roomID, lang: "en"})
			.then((r : any) => {

				if (!r.success)
				{
					reject(r.reason);
				}
				else
				{
					vxChat = new Chat({
						clientId: r.clientID,
						host: r.server,
						version: 'sxc'
					}, new vxChatHandler());

					vxChat.init().then((result) => {
						vxChat.startText().then(() => {});

						vxChat.startStream().then((startResult) => {
							vxSourceSet = startResult;

							resolve(roomID);
						});
					});
				}

				log("startChat", "result", r);

			}).catch((r) => {
				error("startChat", "error", r);
				reject("technical");
			});
	});
}

export function getVXSourceSet() {
	return vxSourceSet;
}

const vxServer = {
	init,
	startChat,
	stopChat,
	getOnlineState,
	sendMessage,
	requestCam2Cam,
	disableCam2Cam,
	sendCam2Cam,
	events,
	getVXSourceSet};
export default vxServer;

class Cam2CamSnapshotProvider implements Provider
{
	getSnapshot(): Promise<string | ArrayBuffer | Blob> {
		return new Promise((resolve, reject) => {
			resolve(cam2CamSnapshotContainer);
		});
	}

	onError(error: Error): void {
	}
}

class vxChatHandler {
    /**
     * Triggered when a single ability is updated
     *
     * @param name {string}
     * @param value {boolean}
     */
    onAbilityUpdate(name, value) { logging.error("onAbilityUpdate", name, value); }

    /**
     * Triggered when host mutes / unmutes audio
     *
     * @param value {boolean}
     */
    onAudioMuteUpdate(value) { logging.error("onAudioMuteUpdate", value); }

    /**
     * Triggered when Chat is paused due to enabled one click payment when the time limit is hit
     */
    onChatPause() { logging.error("onChatPause"); }

    /**
     * Triggered when the chat resumes due to a one click payment done after a previous pause.
     *
     * @param sources
     */
    onChatResume(sources) { logging.error("onChatResume", sources); }

    /**
     * Triggered on chat stop.
     *
     * @param exitCode {int}
     * @param exitMessage {string}
     */
    onChatStop(exitCode, exitMessage) { events.trigger("chatStopped"); logging.error("onChatStop", exitCode, exitMessage); }

    /**
     * Triggered when (video) time limit is updated
     *
     * @param param {string}
     * @param value {int}
     */
    onLimitUpdate(param, value) { logging.error("onLimitUpdate", param, value); }

    /**
     * handle incoming message
     *
     * @param text {string}
     * @param from {string}
     * @param key {string}
     * @param params {object}
     */
    onMessage(text, from, key, params) { events.trigger("messageReceived", text, from); logging.error("onMessageTEST", text, from, key, params); }

    /**
     * Triggered when a query (like "want to access single chat") is fired
     *
     * @param query {Query}
     */
    onQuery(query) { logging.error("onQuery", query); }

    /**
     * Triggered on text chat mute / unmute
     *
     * @param value {boolean}
     */
    onTextMuteUpdate(value) { logging.error("onTextMuteUpdate", value); }

    onSingleModeUpdate() { logging.error("onSingleModeUpdate"); }
}
